<!--
  * Guides Page
  * In-depth tutorials with end to end instructions
  *
  * Copyright (c) 2023 Dev Null Productions - All Rights Reserved
  -->
<template>
  <MainLayout section="guides">
    <div id="guides">
      <h1 id="guides_title">Guides / References</h1>

      <div id="guides_content">
        <p>The following are guides and references pertaining to how to use Block Trac for various solutions and scenarios.</p>

        <b-alert show id="contact_alert">
          <img :src="require('@/assets/email.svg')" width="25" />
          <span>If you need assistance with using Block Trac or would like to report an issue, please <router-link to="/contact">Contact Us</router-link> anytime.</span>
        </b-alert>

        <ul id="guides_list">
          <li>
            <h2><router-link to="/guides/walletwatch">Watch a Wallet</router-link></h2>
            <p>With a few clicks Block Trac can be used to watch any crypto wallet: your own, a celebrity, exchange, and much more... the possibilities are endless!</p>
          </li>

          <li>
            <h2><router-link to="/guides/nftracking">Tracking NFTs</router-link></h2>
            <p>Art is now digital, track it and all other Non-Fungible-Tokens via Block Trac</p>
          </li>

          <li>
            <h2><router-link to="/guides/trading">Trading and Financial System Integration</router-link></h2>
            <p>In this guide, we'll go through the process of quickly feeding data from the distributed ledger into your trading or financial system</p>
          </li>

          <li class="hidden_guide">
            <h2>Accept digital payment in an online store</h2>
            <p>Unlike other solutions, Block Trac gives you the most bang-for-your-buck, complete control of your digital payment workflows and the ability to reroute payment with the click of a button.</p>
          </li>

          <li class="hidden_guide">
            <h2>Webhook Alerts</h2>
            <p>Block Trac allows you to integrate into workflow via webhooks, web requests that are sent when a filters matches transactions.</p>
          </li>

          <li class="hidden_guide">
            <h2>API Reference</h2>
            <p>Technical reference for interfacing with the Block Trac REST API.</p>
          </li>

          <li>
            <h2><router-link to="/jsonpath">JSONPath Reference</router-link></h2>
            <p>Technical reference detailing JSONPath expressions</p>
          </li>

          <li class="hidden_guide">
            <h2>JSONPath Example Database</h2>
            <p>Comprehensive set of expression for many Distributed Ledgers.</p>
          </li>
        </ul>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from './components/MainLayout'
import Blockchain from './mixins/blockchain'

import util from './util'
import ziti from './config/ziti'

export default {
  name: 'Guides',

  mixins : [Blockchain],

  components: {
    MainLayout
  }
}
</script>

<style scoped>
#guides{
  margin-bottom: 25px;
  padding: 5px;
  padding-top: 50px;
}

#guides_title{
  font-family: var(--theme-font3);
  font-weight: bold;
}

#guides_content{
  padding: 15px 25px 0 25px;
}

#guides_list{
  list-style: disclosure-closed;
}

#contact_alert img{
  margin-right: 15px;
}

.hidden_guide{
  display: none;
}
</style>

<style>
.guide_content{
  width: 85%;
  margin: 50px auto;
  border-radius: 15px;
  background-color: white;
  padding: 25px;
}

#main_layout.sm .guide_content,
#main_layout.xs .guide_content{
  width: unset;
}

.guide_content h4{
  margin-top: 25px;
  text-align: center;
}

.guide_content img{
  display: block;
  margin: auto;
  margin-bottom: 10px;
  max-width: 100%;
  border: 1px solid black;
  cursor: pointer;
}

.guide_content .alert img{
  display: unset;
  border: unset;
  margin-right: 10px;
  margin-bottom: unset;
}

.guide_content img.half_width{
  max-width: 50%;
}

.guide_content img.quarter_width{
  max-width: 25%;
}

.guide_section{
  margin-top: 50px;
}

.guide_subsection{
  margin-top: 25px;
}
</style>
